<template>
  <div
    class="modal no-stacking"
    id="Auth0MigrationFeatureDisabledModal"
    data-test-hook="modal-title-Auth0-Migration-Feature-Disabled-Modal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-1 pt-1 pr-0 align-items-center">
          <h2 class="modal-title" data-test-hook="modal-heading-delete-auth0-account-modal">
            <i class="far fa-circle-exclamation colorOrange mr-1"></i>
            {{ $t('xAuth0MigrationInProgressModalTitle') }}
          </h2>
          <button
            class="btn btn-icon-button btn-icon-button--gray"
            @click="closeModal()"
            data-test-hook="x-close-button-delete-auth0-account-modal"
          >
            <i class="fas fa-times" />
          </button>
        </div>

        <div class="modal-body pb-0">
          <div align-h="around" class="row">
            <div class="col" data-test-hook="modal-body-text-delete-auth0-account-modal">
              {{ $t('xAuth0MigrationInProgressModalBody') }}
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex mt-2 p-0">
          <button
            class="btn btn-secondary my-3 ml-3"
            style="flex: 1 1 0;"
            @click="$router.push({ path: `/support` })"
            data-test-hook="continue-button-delete-auth0-account-modal"
          >
            {{ $t('xContactSupport') }}
          </button>
          <button
            type="button"
            class="btn btn-primary my-3 mr-3"
            style="flex: 1 1 0;"
            @click="closeModal()"
            data-test-hook="cancel-button-delete-auth0-account-modal"
          >
            {{ $t('xDone') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants'

export default {
  components: {},
  props: [],
  methods: {
    closeModal() {
      document.getElementById('Auth0MigrationFeatureDisabledModal').style.display = 'none'
    }
  }
}
</script>
<style scoped></style>
